import { SupportedLanguage } from '@/scripts/root/language'

export const langs: SupportedLanguage[] = [
  'en',
  'de',
  'es',
  'fr',
  'pt',
  'zh-TW',
  'it',
  'id',
  'th',
  'ar',
  'kr',
  'jp',
]
